import axiosInstance from './../axiosInstance';

/**
 * @name getPartner
 * @desc Get single partner.
 * @param {string} partnerID
 */
export const getPartner = partnerID => {
  return axiosInstance.get(`partners/${partnerID}`);
};

/**
 *
 * @name getEventPartner
 * @desc Get event partner.
 * @param {string} eventID
 * @param {string} partnerID
 */
export const getEventPartner = (eventID, partnerID) => {
    return axiosInstance.get(`events/${eventID}/partners/${partnerID}`);
};

/**
 * @name saveEventPartner
 * @desc Save event's partner.
 * @param {string} eventID
 * @param {obect} partner
 */
export const saveEventPartner = (eventID, partner) => {
  const { partnerID } = partner;
  return axiosInstance.post(`events/${eventID}/partners/${partnerID}`, partner);
};

/**
 * @name savePartner
 * @desc Save single partner.
 * @param {string} partnerID
 * @param {object} data
 */
export const savePartner = (partnerID, data) => {
  return axiosInstance.post(`partners/${partnerID}`, data);
};

/**
 * @name getPartnerUsers
 * @desc Get partner's users.
 * @param {string} partnerID
 */
export const getPartnerUsers = partnerID => {
  return axiosInstance.get(`partners/${partnerID}/users`);
};

/**
 * @name getPartnersMeta
 * @desc Get partner meta
 */
export const getPartnersMeta = () => {
  return axiosInstance.get('partners/meta');
};